import CustomTags from "components/CustomTags";
import { DATE_FORMAT } from "config/constants";
import { t } from "i18next";
import { formatDateTime } from "utils/dateTime";
import { formatDateTimeFilterTag } from "utils/helperFuncs";

export const FiltersTag = ({
  handleRemoveFilterTag,
  rangeDateTimeFilter,
  transactionTypesFilter,
  actionMapOptions,
}) => {
  const tagsTimeFilter = [
    {
      title: t("product.priceBid.Time"),
      selected: rangeDateTimeFilter,
      key: "timeFilter",
    },
  ];

  const tagsTransactionTypes = [
    {
      title: "HÀNH ĐỘNG",
      options: actionMapOptions,
      selected: transactionTypesFilter,
      key: "manufacturerIDs",
    },
  ];

  const renderTag = (arrTags = [], arrValue, title) => {
    let result = [];
    for (const element of arrValue) {
      const item = arrTags?.find(({ value }) => element === value);
      result.push(item);
    }

    return (
      <div>
        <span className="label">{title}</span>: {result.map((item) => item?.label).join(", ")}
      </div>
    );
  };

  const renderTagTimeRangeFilter = tagsTimeFilter.map(({ selected, title, key }) => {
    return (
      <CustomTags
        handleOnClose={() => handleRemoveFilterTag(key)}
        key={key}
        label={`${title} : ${t("order.orderTag.from")} ${formatDateTime(selected?.from, DATE_FORMAT)} ${t(
          "order.orderTag.to"
        )} ${formatDateTimeFilterTag(selected?.to)}`}
      />
    );
  });

  const renderTagsTransactionTypes = tagsTransactionTypes
    ?.filter(({ selected }) => selected?.length > 0)
    ?.map(({ options, selected, title, key }) => {
      return (
        <CustomTags
          handleOnClose={() => handleRemoveFilterTag(key)}
          key={key}
          label={renderTag(options, selected, title)}
        />
      );
    });

  return (
    <div style={{ marginTop: "12px" }}>
      {rangeDateTimeFilter?.from ? renderTagTimeRangeFilter : ""}
      {transactionTypesFilter?.length > 0 ? renderTagsTransactionTypes : ""}
    </div>
  );
};
